import Vue from "vue";

// 分页大小
Vue.prototype.$limit = 10;

Vue.mixin({
  data() {
    return {
      loaded: false,
      loadedText: "loading...",
    };
  },
  methods: {
    setLoaded(v) {
      this.loaded = v;
    },
    setLoadedText(txt) {
      this.loadedText = txt;
    },
    getImgUrl(fileId) {
      if (!fileId) return "";
      return process.env.VUE_APP_OpenFile_URL + "/" + fileId;
    },
    getOpenFileUrl(fileId) {
      if (!fileId) return "";
      return process.env.VUE_APP_OpenFile_URL + "/" + fileId;
    },
    getTimestamp(v) {
      if (!v) return;
      if (typeof v == "string" && v.length == 10) {
        // Y-m-d 日期补零让时间为0点
        return new Date(v + " 00:00:00").getTime();
      } else {
        return new Date(v).getTime();
      }
    }
  }
});
